import Vue from 'vue';

const outsideClickHandlers = [];

Vue.directive('closable', {
    bind(el, binding, vnode) {
        outsideClickHandlers.unshift((e) => {
            e.stopPropagation();
            const ref = binding.value;
            const handler = ref.handler;
            let exclude = ref.exclude;

            if (!exclude) {
                exclude = [];
            }

            let clickedOnExcludedEl = false;

            exclude.forEach((refName) => {
                if (!clickedOnExcludedEl) {
                    let excludedEl = vnode.context.$refs[refName];
                    excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
                    if (excludedEl) {
                        clickedOnExcludedEl = excludedEl.contains(e.target);
                    }
                }
            });

            let hasElementExceptionClass = null;
            if (ref.classExceptions) {
                hasElementExceptionClass = ref.classExceptions.find((className) => {
                    return e.target.classList.contains(className);
                });
            }

            if (!el.contains(e.target) && !hasElementExceptionClass && !clickedOnExcludedEl) {
                vnode.context[handler]();
            }
        });
        document.addEventListener('click', outsideClickHandlers[0]);
    },

    unbind() {
        document.removeEventListener('click', outsideClickHandlers[0]);
        outsideClickHandlers.shift();
    },
});

Vue.directive('autofocus', {
    // When the bound element is inserted into the DOM...
    inserted(el) {
        // Focus the element
        if (window.innerWidth >= 768) {
            el.focus();
        }
    },
});

Vue.directive('trapfocus', {
    // When the bound element is inserted into the DOM...
    inserted(el, binding, vnode) {
        const closeCb = vnode.data.attrs['data-close-cb'];

        const focusableElements = Array.from(
            el.querySelectorAll(
                'button:not(:disabled):not([tabindex = "-1"]), a:not(:disabled):not([tabindex = "-1"]), input:not(:disabled):not([tabindex = "-1"])'
            )
        );

        setTimeout(() => {
            focusableElements.forEach((x) => {
                x.addEventListener('keydown', (event) => {
                    switch (event.which) {
                        // tab
                        case 9:
                            event.preventDefault();

                            if (!document.activeElement) {
                                focusableElements[0].focus();
                            } else {
                                const focusedIndex = focusableElements.indexOf(document.activeElement);

                                if (event.shiftKey) {
                                    if (focusedIndex === -1 || focusedIndex === 0)
                                        focusableElements[focusableElements.length - 1].focus();
                                    else focusableElements[focusedIndex - 1].focus();
                                } else {
                                    // eslint-disable-next-line
                                    if (focusedIndex === -1 || focusedIndex === focusableElements.length - 1) {
                                        focusableElements[0].focus();
                                    } else {
                                        focusableElements[focusedIndex + 1].focus();
                                    }
                                }
                            }
                            break;

                        // escape
                        case 27:
                            if (closeCb) {
                                closeCb();
                            }
                            event.preventDefault();
                            break;

                        default:
                            // Noop
                            break;
                    }
                });
            });
        }, 500);
    },
});
